// eslint-disable-next-line no-unused-vars
import actionCreator from '../../shared/decorators/actionCreator';
// eslint-disable-next-line no-unused-vars
import recordForUndo from '../../shared/decorators/recordForUndo';
import {
  // eslint-disable-next-line no-unused-vars
  REDUX_NAMESPACE,
  // eslint-disable-next-line no-unused-vars
  FONT_SIZE_UNDO_REDO_GROUP,
  // eslint-disable-next-line no-unused-vars
  TEXT_STRING_UPDATE_GROUP,
} from './constants';
import { DEFAULT_VERTICAL_TEXT_ALIGNMENT, OVERFLOW_X } from '../constants';

const ACTION_CREATORS = {
  @recordForUndo()
  @actionCreator(REDUX_NAMESPACE)
  addText() {},

  @recordForUndo()
  @actionCreator(REDUX_NAMESPACE)
  autoExpandTextHeight(elementId) {
    return { elementId };
  },

  @actionCreator(REDUX_NAMESPACE)
  commitText(contentId) {
    return { contentId };
  },

  @recordForUndo()
  @actionCreator(REDUX_NAMESPACE)
  initTextWrap(contentId, overflowY, height, width) {
    return {
      contentId,
      height,
      overflowY,
      width,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  initializeTextEdit() {},

  /* enforcing text wrap without allowing undo action */
  enforceOverflowXWrap(contentId) {
    return this.updateTextProperties(contentId, { overflowX: OVERFLOW_X.WRAP });
  },

  @recordForUndo()
  @actionCreator(REDUX_NAMESPACE)
  selectTextEffectType(contentId, textEffect) {
    return {
      contentId,
      textEffect,
    };
  },

  @recordForUndo(FONT_SIZE_UNDO_REDO_GROUP)
  setFontSize(contentId, fontSizePx) {
    const properties = {
      fontSize: `${fontSizePx}px`,
    };

    return this.updateTextProperties(contentId, properties);
  },

  setRenderedFontSize(contentId, renderedFontSize) {
    return this.updateTextProperties(contentId, { renderedFontSize });
  },

  @recordForUndo()
  setTextEffectBlur(contentId, blur) {
    return this.updateTextEffectProperties(contentId, { blur });
  },

  @recordForUndo()
  setTextEffectBorderRadius(contentId, borderRadius) {
    return this.updateTextEffectProperties(contentId, { borderRadius });
  },

  @recordForUndo()
  setTextEffectColor(contentId, color) {
    return this.updateTextEffectProperties(contentId, { color });
  },

  @recordForUndo()
  setTextEffectOpacity(contentId, opacity) {
    return this.updateTextEffectProperties(contentId, { opacity });
  },

  @recordForUndo()
  setTextEffectBoxPadding(contentId, boxPadding) {
    return this.updateTextEffectProperties(contentId, { boxPadding });
  },

  @recordForUndo()
  setTextEffectSize(contentId, size) {
    return this.updateTextEffectProperties(contentId, { size });
  },

  @recordForUndo()
  setStrokeColor(contentId, strokeColor) {
    return this.updateTextProperties(contentId, { strokeColor });
  },

  @recordForUndo()
  setStrokeWidth(contentId, strokeWidth) {
    return this.updateTextProperties(contentId, { strokeWidth });
  },

  @recordForUndo()
  setTextEffectXOffset(contentId, xOffset) {
    return this.updateTextEffectProperties(contentId, { xOffset });
  },

  @recordForUndo()
  setTextEffectYOffset(contentId, yOffset) {
    return this.updateTextEffectProperties(contentId, { yOffset });
  },

  @recordForUndo()
  setTextHorizontalAlignment(contentId, alignment) {
    return this.updateTextProperties(contentId, { alignment });
  },

  @recordForUndo()
  setTextFillMode(contentId, mode) {
    return this.updateTextFillProperties(contentId, { mode });
  },

  setTextString(contentId, textString) {
    return this.updateTextProperties(contentId, { textString });
  },

  @recordForUndo()
  setTextLetterSpacing(contentId, letterSpacing) {
    return this.updateTextProperties(contentId, { letterSpacing });
  },

  @recordForUndo()
  setTextLineSpacing(contentId, lineSpacing) {
    return this.updateTextProperties(contentId, { lineSpacing });
  },

  setTextNaturalHeight(contentId, naturalHeight) {
    return this.updateTextProperties(contentId, { naturalHeight });
  },

  setTextNaturalWidth(contentId, naturalWidth) {
    return this.updateTextProperties(contentId, { naturalWidth });
  },

  setTextLines(contentId, textLines) {
    return this.updateTextProperties(contentId, { textLines });
  },

  @recordForUndo()
  setTextOverflowX(contentId, overflowX) {
    return this.updateTextProperties(contentId, { overflowX });
  },

  @recordForUndo()
  setTextOverflowY(contentId, overflowY) {
    return this.updateTextProperties(contentId, { overflowY });
  },

  @recordForUndo()
  setTextPadding(contentId, padding) {
    return this.updateTextProperties(contentId, { padding });
  },

  @recordForUndo()
  setTextVerticalAlignment(
    contentId,
    verticalAlignment = DEFAULT_VERTICAL_TEXT_ALIGNMENT,
  ) {
    return this.updateTextProperties(contentId, { verticalAlignment });
  },

  setTextWrapHeight(contentId, height) {
    return this.updateTextWrapProperties(contentId, { height });
  },

  setTextWrapWidth(contentId, width) {
    return this.updateTextWrapProperties(contentId, { width });
  },

  @recordForUndo()
  setTextWrapBreakWord(contentId, breakWord) {
    return this.updateTextWrapProperties(contentId, { breakWord });
  },

  @actionCreator(REDUX_NAMESPACE)
  startEditingText(contentId) {
    return { contentId };
  },

  @actionCreator(REDUX_NAMESPACE)
  stopEditingText() {},

  @recordForUndo(TEXT_STRING_UPDATE_GROUP)
  @actionCreator(REDUX_NAMESPACE)
  textChanged(contentId, textString) {
    return {
      contentId,
      textString,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  updateTextProperties(contentId, properties) {
    return {
      contentId,
      properties,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  updateTextEffectProperties(contentId, properties) {
    return {
      contentId,
      properties,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  updateTextFillProperties(contentId, properties) {
    return {
      contentId,
      properties,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  updateTextWrapProperties(contentId, properties) {
    return {
      contentId,
      properties,
    };
  },
};

export default ACTION_CREATORS;
